"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
require("./chatList.scss");
const core_1 = require("@material-ui/core");
const svgIcons_1 = require("../../../../svgIcons");
const chatSlice_1 = require("../../../../redux/slices/chatSlice");
const item_1 = __importDefault(require("./item/item"));
const pagination_1 = __importDefault(require("../../../../shared/components/pagination/pagination"));
const common_1 = require("../../../../utils/common");
const noResult_1 = __importDefault(require("../../../../shared/components/noSearchResult/noResult"));
class ChatList extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            searchField: '',
            cancelSearchActive: false,
            showIcon: true,
        };
        this.clearInput = () => {
            this.setState({ searchField: '' });
            this.setState({ showIcon: true });
            this.props.filterChatList(Object.assign(Object.assign({}, this.props.chat.filter), { offset: 0, pattern: '' }));
        };
        this.cancelSearch = () => {
            this.clearInput();
            this.setState({ cancelSearchActive: false });
            this.setState({ showIcon: true });
        };
        this.handleInputChange = (e) => {
            this.setState({ searchField: e.target.value });
            this.setState({ showIcon: e.target.value !== '' ? false : true });
            this.props.filterChatList(Object.assign(Object.assign({}, this.props.chat.filter), { offset: 0, pattern: e.target.value }));
        };
    }
    componentDidMount() {
        this.props.getChatList();
    }
    componentWillUnmount() {
        this.props.resetFilter();
    }
    render() {
        const { chat } = this.props;
        const { showIcon, searchField } = this.state;
        const lastIndex = (chat.filter.offset + 1) * chat.filter.limit;
        const firstIndex = lastIndex - chat.filter.limit;
        const chatList = chat.list.filter(chat => chat.isActive);
        const content = !(chatList === null || chatList === void 0 ? void 0 : chatList.length) ?
            react_1.default.createElement(core_1.Box, { display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', className: 'empty-content' },
                showIcon &&
                    react_1.default.createElement(react_1.Fragment, null,
                        react_1.default.createElement(svgIcons_1.NoMessageIcon, { style: { fontSize: '76px' } }),
                        react_1.default.createElement("p", { className: 'texts' }, "No results to show.")),
                !showIcon &&
                    react_1.default.createElement(react_1.Fragment, null,
                        react_1.default.createElement(noResult_1.default, null))) :
            react_1.default.createElement("div", { className: "chat-list-content" },
                chatList.slice(firstIndex, lastIndex).map((el, i) => {
                    return el.case && el.isActive ? react_1.default.createElement(item_1.default, { key: i, item: el }) : '';
                }),
                chatList.length > chat.filter.limit &&
                    react_1.default.createElement(pagination_1.default, { changeParams: chat.filter, resetConditions: [chat.filter.pattern], changeRequest: this.props.filterChatList, itemsCount: chatList.length, browserHistoryHandle: () => {
                            this.props.filterChatList(Object.assign(Object.assign({}, this.props.chat.filter), { offset: parseInt(common_1.urlPrams("page")) - 1 || 0 }));
                        } }));
        return (react_1.default.createElement("section", { id: 'chat-list-container' },
            react_1.default.createElement(core_1.Box, { className: `d-flex justify-content-between chat-list-header ${chatList.length !== 0 || searchField !== '' ? '' : 'empty-page'}`, pb: 2, pt: 1 },
                react_1.default.createElement("h4", { className: 'heading' }, "Chats"),
                react_1.default.createElement("div", { className: 'search-field-wrapper' },
                    chatList.length !== 0 || searchField !== '' ? react_1.default.createElement(core_1.TextField, { className: 'search-field', size: 'small', placeholder: 'Search...', onChange: this.handleInputChange, onFocus: () => this.setState({ cancelSearchActive: true }), value: this.state.searchField, variant: "outlined", InputProps: {
                            startAdornment: react_1.default.createElement(svgIcons_1.SearchIcon, { className: 'v2-search-icon', style: { fontSize: '14px' } }),
                            endAdornment: react_1.default.createElement("div", null, this.state.searchField && react_1.default.createElement(svgIcons_1.CloseIcon, { onClick: this.clearInput, style: {
                                    fontSize: '12px',
                                    cursor: "pointer"
                                } }))
                        } }) : null,
                    react_1.default.createElement(core_1.Hidden, { smUp: true }, this.state.cancelSearchActive &&
                        react_1.default.createElement("span", { onClick: this.cancelSearch, className: `cancel-search` }, "Cancel")))),
            content));
    }
    ;
}
const mapStateToProps = (state) => {
    const { chat, user } = state;
    return {
        chat,
        user,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getChatList: () => dispatch(chatSlice_1.getChatList()),
        filterChatList: (filter) => dispatch(chatSlice_1.filterChatList(filter)),
        resetFilter: () => dispatch(chatSlice_1.resetFilter())
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ChatList);
